import { CTA } from "@/components/sections";
import SecondaryHero from "@/components/sections/Hero/SecondaryHero";
import { Integrations as IntegrationsSection } from "@/components/sections/Integrations/Integrations";
import { ContentCallout } from "@/components/sections";
import PageWrapper from '@/components/layout/PageWrapper';
import { META } from '@/config/constants';
import { integrationsData } from "@/config/integrationsData";

const Integrations = () => {
  return (
    <PageWrapper
      title={META.INTEGRATIONS.TITLE}
      description={META.INTEGRATIONS.DESCRIPTION}
      keywords={["integrations catalog", "1000+ connectors", "SaaS connectors", "embedded integrations"]}
    >
      <div>
        <SecondaryHero
          title={integrationsData.hero.title}
          subTitle={integrationsData.hero.subTitle}
          description={integrationsData.hero.description}
        />
        <IntegrationsSection />
        <ContentCallout
          title={integrationsData.contentCallout.title}
          card={integrationsData.contentCallout.card}
          cta={integrationsData.contentCallout.cta}
        />
        <CTA
          title={integrationsData.cta.title}
          description={integrationsData.cta.description}
          cta={integrationsData.cta.cta}
        />
      </div>
    </PageWrapper>
  );
};

export default Integrations;
